import { useState } from 'react';
import { Modal } from '@/components/dialogs/Modal';
import { AsyncButton } from '@/components/common/AsyncButton';
import { Select2AsyncMulti } from '@/components/forms/Select2AsyncMulti';
import { useToast } from '@/components/common/toast';
import type { Select2Page } from '@/components/forms/Select2Async';

interface Props {
  show: boolean;
  isGroups: boolean;
  fetch: (term: string, page: number) => Promise<Select2Page>;
  onConfirm: (targets: string[]) => void;
  onClose: () => void;
}

// Add Group(s) / Add Login(s) to the staged target set.
export function AddTargetDialog({ show, isGroups, fetch, onConfirm, onClose }: Props) {
  const toast = useToast();
  const [values, setValues] = useState<string[]>([]);

  const close = () => {
    setValues([]);
    onClose();
  };

  const confirm = () => {
    if (values.length === 0) {
      toast.error(isGroups ? 'Select at least one group' : 'Select at least one login');
      return;
    }
    onConfirm(values);
    setValues([]);
  };

  return (
    <Modal
      show={show}
      title={isGroups ? 'Add Groups' : 'Add Logins'}
      onClose={close}
      footer={
        <>
          <button type="button" className="btn btn-light btn-sm" onClick={close}>Cancel</button>
          <AsyncButton className="btn btn-primary btn-sm" onClick={confirm}>Add</AsyncButton>
        </>
      }
    >
      <label className="form-label">{isGroups ? 'Groups' : 'Logins'}</label>
      <Select2AsyncMulti
        placeholder={isGroups ? 'Select Groups' : 'Select Logins'}
        fetch={fetch}
        value={values}
        onChange={setValues}
      />
    </Modal>
  );
}
